angular.extend(window.config, {
  appId: 'kb',
  appPath: window.config.kbRoute,
  appName: 'Reference Docs',
});
